var map = {
	"./camera.json": 81452,
	"./common.json": 72110,
	"./countries.json": 27035,
	"./docs-verification-widget.json": 2571,
	"./files-uploader.json": 77363,
	"./language-selector.json": 85457,
	"./requirements.json": 16231,
	"./validation.json": 27900,
	"lang/locales/es/camera.json": 81452,
	"lang/locales/es/common.json": 72110,
	"lang/locales/es/countries.json": 27035,
	"lang/locales/es/docs-verification-widget.json": 2571,
	"lang/locales/es/files-uploader.json": 77363,
	"lang/locales/es/language-selector.json": 85457,
	"lang/locales/es/requirements.json": 16231,
	"lang/locales/es/validation.json": 27900
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43775;